import React from "react";

/** Icono tipo credencial: rojo = clic inactiva, verde = clic activa. */
const LicenseToggleIcon = ({ licenseActive, size = 28 }) => {
  const color = licenseActive ? "#dc2626" : "#16a34a";
  return (
    <svg
      width={size}
      height={size * 0.72}
      viewBox="0 0 48 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="2"
        y="2"
        width="44"
        height="26"
        rx="3"
        stroke={color}
        strokeWidth="2.5"
        fill={licenseActive ? "#fee2e2" : "#dcfce7"}
      />
      <circle cx="14" cy="15" r="4.5" fill={color} />
      <path
        d="M9 22c0-2.8 2.2-5 5-5s5 2.2 5 5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line x1="26" y1="10" x2="40" y2="10" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      <line x1="26" y1="15" x2="38" y2="15" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      <line x1="26" y1="20" x2="36" y2="20" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      <rect x="10" y="29" width="4" height="3" fill={color} />
      <rect x="34" y="29" width="4" height="3" fill={color} />
    </svg>
  );
};

export default LicenseToggleIcon;
